export const enum ContactDetail {
    Email = "email",
    MobilePhone = "mobilePhone",
    DirectPhone = "directPhone",
    EmailAndMobilePhone = "both",
}
